module.exports = __webpack_public_path__ + "static/media/26UNRWA5.b0eb2449.jpg";